import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface BookingConfig {
    id?: string;
    companyId?: string;
    timezone: string;
    minDurationMinutes: number;
    maxDurationMinutes: number;
    stepMinutes: number;
    bufferMinutes: number;
    advanceBookingDays: number;
    minNoticeHours: number;
    cancellationCutoffHours: number;
    allowReschedule: boolean;
    maxBookingsPerDay: number | null;
    status?: string;
}

export interface WorkingHourDay {
    dayOfWeek: string;
    isWorkingDay: boolean;
    startTime: string | null;
    endTime: string | null;
}

export interface BlockedDate {
    id?: string;
    companyId?: string;
    date: string;
    type: string;
    reason: string;
    isRecurring: boolean;
}

@Injectable({ providedIn: 'root' })
export class BookingConfigService {
    constructor(private api: ApiService) {}

    getConfig(): Observable<any> {
        return this.api.get<any>('/api/booking/config');
    }

    saveConfig(payload: Omit<BookingConfig, 'id' | 'companyId' | 'status'>): Observable<any> {
        return this.api.post<any>('/api/booking/config', payload);
    }

    deleteConfig(configId: string): Observable<any> {
        return this.api.delete<any>(`/api/booking/config/${configId}`);
    }

    getWorkingHours(): Observable<any> {
        return this.api.get<any>('/api/booking/config/working-hours/default');
    }

    saveWorkingHours(schedule: WorkingHourDay[]): Observable<any> {
        return this.api.post<any>('/api/booking/config/working-hours', { schedule });
    }

    getBlockedDates(): Observable<any> {
        return this.api.get<any>('/api/booking/blocked-dates');
    }

    addBlockedDate(payload: Omit<BlockedDate, 'id' | 'companyId'>): Observable<any> {
        return this.api.post<any>('/api/booking/blocked-dates', payload);
    }

    deleteBlockedDate(id: string): Observable<any> {
        return this.api.delete<any>(`/api/booking/blocked-dates/${id}`);
    }
}
